/* RESPONSIBLE TEAM: team-proactive-support */
import HeaderConfiguration from 'embercom/objects/content-editor/header-configuration';

export default HeaderConfiguration.extend({
  init(inputs) {
    inputs.component = 'content-editor/headers/series-mode/standard-header';
    this._super(...arguments);
  },
});
